import styles from "../opsDashboard.module.css";

/**
 * Typesets a tile's rule as maths.
 *
 * The backend sends a small LaTeX-ish notation rather than pre-rendered markup, so the
 * rule that applies a threshold is still the thing that states it:
 *
 *     frac{numerator}{denominator}    a stacked fraction
 *     anything else                   inline, in the maths face
 *
 * Hand-rolled rather than KaTeX or MathJax. Those render a paper; this renders eight
 * fractions and some comparison operators, and would cost ~270KB of script and webfonts
 * on a page whose whole job is to load fast enough to be checked every morning. MathML
 * would also do it natively, but authoring it for these long plain-English operands is
 * far more markup than the two rules below.
 */
export function Formula({ source }: { source: string }) {
    // Split on the fractions, keeping them: ["a < ", "frac{x}{y}", " and ..."]
    const parts = source.split(/(frac\{[^{}]*\}\{[^{}]*\})/g).filter(Boolean);

    return (
        <span className={styles.formula}>
            {parts.map((part, i) => {
                const frac = part.match(/^frac\{([^{}]*)\}\{([^{}]*)\}$/);
                if (!frac) return <span key={i}>{part}</span>;
                return (
                    <span key={i} className={styles.frac}>
                        <span className={styles.fracNum}>{frac[1]}</span>
                        <span className={styles.fracDen}>{frac[2]}</span>
                    </span>
                );
            })}
        </span>
    );
}
